import type { VFC } from 'react'
import { useFormContext } from 'react-hook-form'
import { SuccessIcon } from '@panwds/react-ui'
import KeyValueDisplay from './common/KeyValueDisplay'
import type { CommonStoreState } from '../store'

type DefaultAddonFieldProps = {
  state: CommonStoreState,
  subTitle?: string,
}

const Activated = () => (
  <div>
    <SuccessIcon size='xs' />
    <span className='tw-ml-2'>Activated</span>
  </div>
)

const DefaultAddonField: VFC<DefaultAddonFieldProps> = ({ state }) => {
  const { setValue } = useFormContext()
  if (state.loadingHashes) {
    return <></>
  }
  const renderAddOnElements: any[] = []
  const activatableAddons: any[] = []
  const appAddonsManifest = state?.manifest?.flags?.addons
  appAddonsManifest?.forEach(addonDef => {
    const addOnLicense = state.licenses?.get(addonDef?.app_id)?.licenses
    if (addOnLicense?.length) {
      addOnLicense.forEach(eachLicense => {
        if (addonDef.autoActivate && !eachLicense?.license_expiration) { //available for activation
          activatableAddons.push({
            app_id: eachLicense.app_id,
            required_x_signature: addonDef.required_x_signature,
          })
        }
        const addOnDetails = {
          title: eachLicense.license_display_name || '',
          data: [
            ...addonDef.licenseTypeTitle ? [{
              label: `${addonDef.licenseTypeTitle}`,
              value: `${addonDef.licenseTypeEnums?.[eachLicense.license_type]}` || `${eachLicense.license_type}`
            }] : [],
            ...eachLicense?.license_expiration ? [{
              label: 'activate',
              value: <Activated />,
              hideLabel: true
            }] : [],
          ]
        }
        renderAddOnElements.push(<KeyValueDisplay {...addOnDetails } showTopDivider={true} />)
      })
    }
  })
  if (activatableAddons.length) {
    setValue('appAddons', activatableAddons)
  }

  if (renderAddOnElements.length) {
    return <>{renderAddOnElements.map(e => e)}</>
  }
  return <></>
}

export default DefaultAddonField

